import { render, staticRenderFns } from "./pagination.component.vue?vue&type=template&id=086557d0&scoped=true&"
import script from "./pagination.component.vue?vue&type=script&lang=ts&"
export * from "./pagination.component.vue?vue&type=script&lang=ts&"
import style0 from "./pagination.component.vue?vue&type=style&index=0&id=086557d0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086557d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VPagination,VSelect})
